import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import {gettext} from 'utils/text';
import {updateWorker} from 'ducks/workers';


export class PinCodeView extends React.Component {
    static propTypes = {
        deviceAuthorised: PropTypes.bool.isRequired,
        user: PropTypes.shape({
            id: PropTypes.number.isRequired,
            name: PropTypes.string.isRequired,
            email: PropTypes.string.isRequired,
            role: PropTypes.string.isRequired,
        }),

        // Redux state
        error: PropTypes.string,

        // Redux actions
        updateWorker: PropTypes.func.isRequired,
    };

    static defaultProps = {
        user: null,
        error: null,
    };

    state = {
        pinCode: '',
    };

    onPinCodeInputChange = (e) => {
        const value = e.target.value;
        this.setState({pinCode: value});
    };

    onUpdateWorker = (e) => {
        this.setState({pinCode: ''});
        if (this.isInputValid()) {
            this.props.updateWorker(this.state.pinCode);
        }
        e.preventDefault();
    };

    isInputValid = () => (this.state.pinCode.length > 3);

    render() {
        if (!this.props.deviceAuthorised) {
            return (
                <div className="alert alert-primary mx-auto w-600" role="alert">
                    {gettext('Device needs to be authorised. Contact your supervisor.')}
                </div>
            );
        }
        if (this.props.user !== null) {
            return (
                <div className="alert alert-warning mx-auto w-600" role="alert">
                    {gettext('You are logged in. Please log out to use production view.')}
                </div>
            );
        }

        const alert = (
            <div className="alert alert-danger" role="alert">
                {this.props.error}
            </div>
        );
        return (
            <div>
                <div className="card mx-auto w-400">
                    <div className="card-body">

                        <h3 className="mb-3">{gettext('Production')}</h3>
                        <form className="form-group" onSubmit={this.onUpdateWorker}>
                            <label htmlFor="pinCode">{gettext('Log in with your pin code')}</label>
                            {this.props.error ? alert : null}
                            <input
                                id="pinCode"
                                className="form-control"
                                type="number"
                                value={this.state.pinCode}
                                onChange={this.onPinCodeInputChange}
                                autoFocus
                            />
                            <small
                                id="pinCode"
                                className="form-text text-muted"
                            >
                                {gettext('Do not share your pincode')}
                            </small>
                            <button
                                type="submit"
                                className="btn btn-primary btn-block mt-3"
                                disabled={!this.isInputValid()}
                            >
                                {gettext('Enter')}
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    error: state.workers.error,
});

const mapDispatchToProps = dispatch => ({
    updateWorker: pincode => dispatch(updateWorker(pincode)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(PinCodeView);



// WEBPACK FOOTER //
// ./src/components/PinCodeView/PinCodeView.js